export default __webpack_public_path__ + "static/media/group1.a72507b2.png";